export const MAX_IMAGE_SIZE = 1024 * 10000;
export const MAX_AVATAR_DIMENSION = 1024;
export const IMAGE_QUALITY = 0.7;
